<template>
  <div class="index-page">
    <el-container class="index-page__wrapper">
      <div style="width: 100%; background-color: #ffffff;">
        <el-header class="index__header">
          <div class="index__header__wrapper">
            <img class="index__header__img" src="../assets/top1.png" alt="top1.png" />
          </div>
          <div class="index__header__menu__wrapper">
            <el-menu :default-active="activeIndex" class="index__header__menu" mode="horizontal"
              background-color="#409EFF" text-color="#FFFFFF" active-text-color="#FFFFFF" @select="changeRoute">
              <el-menu-item index="1">网站首页</el-menu-item>
              <el-submenu index="2">
                <template slot="title">实验室介绍</template>
                <el-menu-item index="2-1">实验室简介</el-menu-item>
                <el-menu-item index="2-2">实验室领导</el-menu-item>
                <el-menu-item index="2-3">研究方向</el-menu-item>
                <el-menu-item index="2-4">学术委员会</el-menu-item>
                <el-menu-item index="2-5">管理委员会</el-menu-item>
              </el-submenu>
              <el-submenu index="3">
                <template slot="title">研究人员</template>
                <el-menu-item index="3-1">固定研究人员</el-menu-item>
                <el-menu-item index="3-2">杰出人才</el-menu-item>
              </el-submenu>
              <el-submenu index="4">
                <template slot="title">研究成果</template>
                <el-menu-item index="4-1">标志性成果</el-menu-item>
                <el-menu-item index="4-2">近五年项目</el-menu-item>
                <el-menu-item index="4-3">获奖成果</el-menu-item>
                <el-menu-item index="4-4">论文论著</el-menu-item>
                <el-menu-item index="4-5">授权专利</el-menu-item>
                <el-menu-item index="4-6">软件著作权</el-menu-item>
              </el-submenu>
              <el-submenu index="5">
                <template slot="title">国际合作与交流</template>
                <el-menu-item index="5-1">客座访问</el-menu-item>
                <el-menu-item index="5-2">合作项目</el-menu-item>
                <el-menu-item index="5-3">学术会议</el-menu-item>
              </el-submenu>
              <el-submenu index="6">
                <template slot="title">运行管理</template>
                <el-menu-item index="6-1">组织机构</el-menu-item>
                <el-menu-item index="6-2">管理条例</el-menu-item>
              </el-submenu>
              <el-submenu index="7">
                <template slot="title">开放研究基金</template>
                <el-menu-item index="7-1">申请指南</el-menu-item>
                <el-menu-item index="7-2">申报书</el-menu-item>
                <!-- <el-menu-item index="7-3">课题成果</el-menu-item> -->
              </el-submenu>
            </el-menu>
          </div>
        </el-header>
      </div>
      <div style="width: 100%; background-color: #73b6fc;">
        <el-main class="main__wrapper">
          <router-view></router-view>
        </el-main>
      </div>
      <div style="width: 100%;">
        <el-footer class="index__footer">
          <div class="footer__wrapper">
            <p class="footer__links">
              <el-link class="footer__link" type="info" :underline="false" href="javascript:void(0)">
                联系我们
              </el-link>
              <el-link class="footer__link" type="info" :underline="false" href="javascript:void(0)" target="_blank">
                后台管理
              </el-link>
              <el-link class="footer__link" type="info" :underline="false" href="javascript:void(0)" target="_blank">
                平台管理
              </el-link>
              <el-link class="footer__link" type="info" :underline="false" href="javascript:void(0)" target="_blank">
                办公室入口
              </el-link>
            </p>
            <p class="footer__address">
              地址：江苏省南京市江宁区佛城西路189号 河海大学牛首山科技园
            </p>
            <p class="footer__contact">
              邮编：211100 电话: 025-58099106 传真：025-58099106
            </p>
            <p class="footer__copyright">
              版权所有：水利部水利大数据重点实验室
            </p>
          </div>
        </el-footer>
      </div>
    </el-container>
  </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      activeIndex: '1',
    }
  },
  methods: {
    changeRoute(a, indexpath) {
      console.log(a);
      console.log(indexpath);
      let data = {
        myfirstTitle: indexpath[0],
        mysecondTitle: indexpath[1]
      }
      if (indexpath[0] === '2') {
        this.$router.push({
          path: '/lab',
          query: data
        })
      } else if (indexpath[0] === '1') {
        this.$router.push('/')
        
      } else if (indexpath[0] === '3') {
        this.$router.push({
          path: '/renyuan',
          query: data
        })
      } else if (indexpath[0] === '4') {
        this.$router.push({
          path: '/cg',
          query: data
        })
      } else if (indexpath[0] === '5') {
        this.$router.push({
          path: '/gj',
          query: data
        })
      } else if (indexpath[0] === '6') {
        this.$router.push({
          path: '/yg',
          query: data
        })
      } else if (indexpath[0] === '7') {
        this.$router.push({
          path: '/kf',
          query: data
        })
      }else if (indexpath[0] === '8') {
        this.$router.push({
          path: '/editor',
          query: data
        })
      }
      
    }
  },
  // watch: {
  //   $route: {
  //     handler() {
  //       this.query = this.$route.query;
  //       console.log("路由变化了", this.query);
  //     },
  //     deep: true,
  //   },
  // },
}
</script>

<style lang="less" scoped>
.index-page {
  width: 1002px;
  margin: 0 auto;
}

.index-page__wrapper {
  flex-direction: column;
}

.index__header {
  padding: 0;
}

.index__header__wrapper {
  overflow: hidden;
}

.index__header__img {
  /* // width: 600px;
  // height: 170px; */
  width:100%;
  vertical-align: top;
  float: left;
}

.index__header__menu {
  padding: 0 63px;
  text-align: center;
}

.el-menu-item {
  text-align: center;
}

.main__wrapper {
  padding: 0 !important;
}

.carousel {
  padding: 0 !important;
}

.carousel__img {
  width: 100%;
  height: 100%;
}

.el-row {
  padding: 20px;
}

.text {
  font-size: 14px;
}

.item {
  display: flex;
  margin-bottom: 18px;
}

.clearfix {
  margin-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.box-card {
  width: 480px;
}

.card-title {
  background-color: #0064c8;
  float: left;
  padding: 5px;
  border-radius: 5px 5px 0 0;
  color: #fff;
}

.news__link {
  flex: 1;
  text-align: left;
  justify-content: left;
  overflow: hidden;

  white-space: nowrap;
}

.time {
  width: 100px;
}

.cube {
  width: 280px;
  height: 292px;
  box-sizing: border-box;
  overflow: hidden;
}

.experimental-platform {
  border-top: 2px solid #2eb6ce;
  background-color: #dbf4f8;
  position: relative;
}

.needs-collection__wrapper {
  border-top: 2px solid #d3d8dc;
  background-color: #e9eef2;
  padding: 0 10px;
}

.friendly-link__wrapper {
  border-top: 2px solid #46b98a;
  background-color: #0379d0;
}

.cube__title {
  font-size: 18px;
  line-height: 40px;
  margin-bottom: 5px;
}

.experimental-platform__title {
  color: #28aac1;
}

.needs-collection__title {
  color: #0064c8;
}

.friendly-link__title {
  color: #40ac80;
}

.cube__img {
  width: 260px;
  height: 245px;
  overflow: hidden;
  box-sizing: border-box;
  margin: 0 auto;
}

.experimental-platform__img {
  height: 235px;
}

.friendly-link__img {
  width: 260px;
  height: 55px;
}

.experimental-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.experimental-btn-link {
  display: block;
  width: 220px;
  height: 35px;
  font-size: 16px;
  border-radius: 3px;
  color: #fff;
  text-decoration: none;
  line-height: 35px;
  text-align: center;
  background-color: #2eb6ce;
}

.friendly-link-link {
  display: block;
  width: 260px;
  height: 55px;
  text-decoration: none;
  margin-bottom: 5px;
}

.needs-collection__btn {
  width: 100% !important;
}

.index__footer {
  padding: 0;
  width: 100%;
}

.footer__wrapper {
  background-color: #409eff;
  width: 100%;
  padding: 5px 16px;
  box-sizing: border-box;
}

.footer__link {
  padding: 0 10px;
  border-right: 1px solid #909399;
  color: #fff;
}

.footer__link:first-child {
  padding-left: 0;
}

.footer__link:last-child {
  border-right: none;
}
</style>
